import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectPaymentList } from '../../../../redux/payment-methods/selectors';

import Card from './Card';
import mapAccountVaultCardsToItems from '../../../../utils/converters/map-account-vault-cards-to-items';

import styles from './styles.module.styl';

const Payments = () => {
  const paymentList = useSelector(selectPaymentList);

  const renderLocation = useMemo(() => {
    return paymentList.map(({ name, accountvaults, id }) => {
      return (
        <div className={styles.section} key={id}>
          <div className={styles.header}>
            <span className={styles.title}>{name}</span>
          </div>

          <div className={styles.cards}>
            {accountvaults.map(({ accountvault }) => (
              <div className={styles.section} key={accountvault.id}>
                <Card card={mapAccountVaultCardsToItems(accountvault)} />
              </div>
            ))}
          </div>
        </div>
      );
    });
  }, [paymentList]);

  return <div className={styles.container}>{renderLocation}</div>;
};

export default Payments;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfilePaymentMethods/Payments/index.jsx